import { Grid, Tooltip } from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import FolderDeleteIcon from "@mui/icons-material/FolderDelete";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import CancelIcon from "@mui/icons-material/Cancel";
import "@/components/files/documents.css";
import { IFolderProps } from "@/types/FolderItem";
import styles from "@/components/files/folderButtons.module.css";
import GenericButton from "@/components/forms/inputs/button/genericButton";
import Restricted from "@/consumer/restricted";

interface FolderButtonProps {
  item: IFolderProps;
  openEditModal?: (item: IFolderProps) => void;
  disabled?: boolean;
  openCreateSubFolderModal?: (item: IFolderProps) => void;
  deleteFolder?: (item: IFolderProps) => void;
  className?: string;
}

export function FolderButtons(props: FolderButtonProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  let editButton = <></>;
  editButton = (
    <GenericButton
      variant="icon"
      color="iconBase"
      onClick={() => props.openEditModal?.(props.item)}
    >
      <EditOutlinedIcon fontSize="small" />
    </GenericButton>
  );

  let createFolderButton = <></>;
  createFolderButton = (
    <GenericButton
      variant="icon"
      color="secondary"
      type="button"
      disabled={props.disabled}
      onClick={() => props.openCreateSubFolderModal?.(props.item)}
    >
      <CreateNewFolderIcon fontSize="small" />
    </GenericButton>
  );
  let deleteFolderButton = <></>;
  if (props.item.name !== "upload" && !props.item.children) {
    deleteFolderButton = (
      <GenericButton
        variant="icon"
        color="error"
        type="button"
        onClick={() => props.deleteFolder?.(props.item)}
      >
        <FolderDeleteIcon fontSize="small" />
      </GenericButton>
    );
  }

  return (
    <Grid item className={`${styles.buttonGroup} ${props.className ?? ""}`}>
      {editButton}
      <Restricted permissionRequired="frontend_view_entity_translation">
        <Tooltip
          arrow
          placement="top"
          enterDelay={1000}
          enterNextDelay={250}
          title={t("translation_edit")}
        >
          <GenericButton
            variant="icon"
            aria-label={t("translation_edit")}
            onClick={(event) => {
              event.stopPropagation();
              navigate(`/folder/${props.item.id}/translation`);
            }}
          >
            <LanguageIcon fontSize="small" />
          </GenericButton>
        </Tooltip>
      </Restricted>
      {createFolderButton}
      {deleteFolderButton}
    </Grid>
  );
}

interface MoveFolderProps {
  adminMode?: boolean;
  subjectId?: string;
  moveFolderSource?: IFolderProps[] | any;
  source?: string;
  item: IFolderProps;
  subFolderIds?: string[];
  cancelFolderMove?: () => void;
  handleMoveFolderSource?: (item: any) => void;
  handleMoveFolderTarget?: (item: any) => void;
  className?: string;
}

export function MoveFolderButton(props: MoveFolderProps) {
  let moveFolderButton = <></>;
  if (props.adminMode || props.subjectId) {
    let icon = <DriveFileMoveIcon fontSize="small" />;
    if (props?.moveFolderSource?.length !== 0 || props.source === "document") {
      icon = <ArrowCircleLeftIcon fontSize="small" />;
    }

    if (props?.subFolderIds?.includes(props.item.id)) {
      moveFolderButton = <></>;
    } else if (props.moveFolderSource.id === props.item.id) {
      moveFolderButton = (
        <GenericButton
          onClick={props.cancelFolderMove}
          variant="icon"
          color="error"
        >
          <CancelIcon fontSize="small" color="error" />
        </GenericButton>
      );
    } else {
      moveFolderButton = (
        <GenericButton
          variant="icon"
          color="iconBase"
          onClick={function () {
            if (props.moveFolderSource.length === 0) {
              return props?.handleMoveFolderSource?.(props.item);
            } else {
              return props.handleMoveFolderTarget?.(props.item);
            }
          }}
        >
          {icon}
        </GenericButton>
      );
    }
  }

  return (
    <Grid item className={props.className}>
      {moveFolderButton}
    </Grid>
  );
}
